export default function FilterInput({
  value,
  onBlur,
  onChange,
  disabled = false,
  placeholder,
  styles = "",
  maxLength = undefined,
}) {
  return (
    <input
      className={`peer border-2 h-[40px] focus:outline-none rounded-lg p-2 lg:w-[17rem] bg-[#e5e7eb] border-none ${styles}`}
      type="text"
      value={value}
      placeholder={placeholder}
      onBlur={onBlur}
      onChange={onChange}
      disabled={disabled}
      maxLength={maxLength}
    />
  );
}
